import {NavMenu}  from './NavMenu';
import React, { useState, useContext, useEffect } from 'react';
import PageFooter from './PageFooter';
import { Container } from 'reactstrap';
import { Outlet } from 'react-router-dom';
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from 'reactstrap';
import SearchForm from './SearchForm';
import { SearchFields } from '../services/interfaces';
import { PageContextProvider, PageContext } from './PageContext';
import {Expand} from './Expand';
import { MMExpand } from './MMExpand';
import { NotificationList } from './NotificationList';
import { Drawer, DrawerContent, DrawerSelectEvent } from '@progress/kendo-react-layout';
import { UserContext } from './UserContext';
import { useThemeSwitcher } from 'react-css-theme-switcher';


function Layout () {

    const [showSearch, setShowSearch]=useState(false);
    const toggleSearch=()=>setShowSearch(!showSearch);
    const toggleExpand=()=>pageContext?.setShowExpand(!pageContext?.showExpand);
    const [searchFormFields, setSearchFormFields]=useState<SearchFields>();
    const pageContext = useContext(PageContext);
    const userContext = useContext(UserContext);
    const setFields =(fields:SearchFields)=>{
        console.log("Search Fields Updated");
        updatePageContext(fields);
    };

    const clearFields=()=>{
        pageContext?.setPage({...pageContext.page,fields: ''});
    }
    const updatePageContext=(fields:SearchFields)=>{
        //console.log(fields);
        const searchFields = JSON.stringify(fields);
        pageContext?.setPage({...pageContext.page,fields: searchFields || ''});
    }
    const { switcher, themes, currentTheme, status } = useThemeSwitcher();

    return (
        userContext?.user.username !== "" ? (
            <div>
                <title>AdTracker:Online</title>
                <NotificationList></NotificationList>
                <NavMenu toggleSearch={()=>toggleSearch()}  />
                <Container fluid tag="main" className='atolMain'>
                        <Outlet />
                </Container>
                <Offcanvas id='searchForm' fade={false} isOpen={showSearch} toggle={toggleSearch} data-bs-theme={currentTheme}>
                    <OffcanvasHeader toggle={toggleSearch}>
                        Search
                    </OffcanvasHeader>
                    <OffcanvasBody>
                        <SearchForm toggleSearch={()=>toggleSearch()} setFields={setFields} fields={pageContext?.page.fields||""} clearFields={clearFields}/>
                    </OffcanvasBody>
                </Offcanvas>
                <Offcanvas id='expand' fade={true} direction='end' isOpen={pageContext?.showExpand} toggle={toggleExpand} scrollable={true} className={pageContext?.expandMax?'expandMax':'expand'} data-bs-theme={currentTheme}>                    
                    {userContext?.user.type==40 || userContext?.user.type==41?
                    <MMExpand></MMExpand>
                    :<Expand></Expand>}
                </Offcanvas>
                <PageFooter />
            </div>
            ) : (
                <div>
                <NavMenu toggleSearch={()=>toggleSearch()}  />
                <Container fluid tag="main" className='atolMain'>
                        <Outlet />
                </Container>
                <PageFooter />
                </div>
            )
        );
}

export default Layout;